export enum LocalStorageKeys {
  accessToken = 'accessToken',
  tenantRef = 'tenantRef',
  tenantId = 'tenantId',
  lon = 'lon',
  lat = 'lat',
  zoom = 'zoom',
  themePalette = 'themePalette',
}
